import React from "react"
import { Switch } from "react-router-dom"

import Route from "./Route"

import SignIn from "../pages/SignIn"
import Dashboard from "../pages/Dashboard"
import Profile from "../pages/Profile"
import SchoolClass from "../pages/SchoolClass"
import Students from "../pages/Students"
import Absences from "../pages/Absences"
import Users from "../pages/Users"

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />

    <Route path="/profile" component={Profile} isPrivate />
    <Route path="/dashboard" component={Dashboard} isPrivate />

    <Route path="/school-class" component={SchoolClass} isPrivate />
    <Route path="/students" component={Students} isPrivate />
    <Route path="/absences" component={Absences} isPrivate />
    <Route path="/users" component={Users} isPrivate />
  </Switch>
)

export default Routes
